module.exports = __webpack_public_path__ + "static/media/delran.9d033444.jpg";